import axios from "axios";
import {getLanguageNow} from "../_metronic/i18n";

const getPage = async (name) => {
  const lang = getLanguageNow();

  return axios.get(
    `/api/pages/${name}/${lang}`,
    {},
    { withCredentials: true }
  );
};

export default getPage;
